import { Component, OnInit } from '@angular/core';

import { CaseWizardService } from 'src/app-client/_dataservices/CaseWizardService';
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";


@Component({
  selector: 'app-confirm-case-step',
  templateUrl: './confirm-case-step.component.html',
  styleUrls: ['./confirm-case-step.component.css']
})
export class ConfirmCaseStepComponent implements OnInit
{

  public isLoading: boolean = false;
  public confirmationCheckboxChecked: boolean = false;
  public caseConfirmOptions = [
    { value: false, display: "Cancelar" },
    { value: true, display: "Confirmar" },
  ];

  constructor(
    public caseWizardService: CaseWizardService,
  )
  {
    caseWizardService.confirmCase = true;
  }

  ngOnInit(): void
  {
    BroadcastManager.Instance.broadcast("finalStepValid", false);
  }

  public openPDFDocument()
  {
    window.open(this.getUrlPDF, '_blank', 'noreferrer');
  }

  public get getUrlPDF(): string
  {
    return this.caseWizardService.urlPDF;
  }

  public onCheckboxChange(e)
  {
    this.confirmationCheckboxChecked = e;
    if (this.confirmationCheckboxChecked == true) {
      BroadcastManager.Instance.broadcast("finalStepValid", true);
    }
    else {
      BroadcastManager.Instance.broadcast("finalStepValid", false);
    }
  }
}
